import {GetterTree} from 'vuex'

export const getters: GetterTree<any, any> = {

    businessRulesActive (state, getters, rootState, rootGetters) {

        if (!state.settings.business_rules_json_query || !state.settings.business_rules_json_filter) {
            return false;
        }

        return true;
    }
}
